import { createInboxApi } from './create-inbox-api.js'

export const inboxApi = createInboxApi()
